import { useNavigate } from 'react-router-dom';
import TopNav from '../components/navigation_bar/TopNav';
import '../assets/css/terms.css';

function TermsOfService() {
  const navigate = useNavigate();

  const handleReturnHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="terms-page">
      <TopNav />
      <main className="terms-main">
        <div className="terms-card">
          <header className="terms-header">
            <span className="terms-badge">Legal</span>
            <h1 className="terms-title">TERMS OF SERVICE FOR FREEFLASH (PROTOTYPE)</h1>
            <p className="terms-updated">Last Updated: October 22, 2026</p>
          </header>

          <div className="terms-callout">
            <p>
              <strong>Yo:</strong> FreeFlash is currently offered as a prototype / beta version for testing and evaluation purposes. The Service is provided on an &ldquo;AS IS&rdquo; and &ldquo;AS AVAILABLE&rdquo; basis.
            </p>
          </div>

          <section className="terms-section">
            <p>
              Please read these Terms of Service (&ldquo;Terms&rdquo;) carefully before using the FreeFlash application, website, or associated services (collectively, the &ldquo;Service&rdquo;) operated by me (&ldquo;I&rdquo;, &ldquo;me&rdquo;, or &ldquo;my&rdquo;).
            </p>
            <p>
              By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, you do not have permission to access the Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>1. Prototype and &ldquo;As-Is&rdquo; Status</h2>
            <p>
              FreeFlash is currently offered as a prototype / beta version for testing and evaluation purposes.
            </p>
            <p>
              The Service is provided on an &ldquo;AS IS&rdquo; and &ldquo;AS AVAILABLE&rdquo; basis without warranties of any kind, either express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement, or course of performance.
            </p>
            <p>I do not warrant that:</p>
            <ul>
              <li>The Service will function uninterrupted, secure, or available at any particular time or location.</li>
              <li>Any errors or defects will be corrected.</li>
              <li>The Service is free of viruses or other harmful components.</li>
              <li>The results, translations, language lessons, flashcards, or content provided will meet your requirements or be accurate, complete, or error-free.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>2. Absolute Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by applicable law, in no event shall I or FreeFlash be liable for any direct, indirect, incidental, special, consequential, or punitive damages, including without limitation:
            </p>
            <ul>
              <li>App crashes, loss of saved flashcards, progress resets, or service interruptions;</li>
              <li>Unauthorized access, use, or alteration of your transmissions or content;</li>
              <li>Data breaches;</li>
            </ul>
            <p>
              resulting from your access to or use of (or inability to access or use) the Service, whether based on warranty, contract, tort (including negligence), or any other legal theory, whether or not I have been informed of the possibility of such damage.
            </p>
            <p>
              If, notwithstanding the other provisions of these Terms, FreeFlash is found to be liable to you for any damage or loss, my total aggregate liability shall not exceed zero US Dollars ($0.00 USD) or the total amount paid by you to me in the past six months, whichever is lower.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. User Accounts &amp; Content</h2>
            <ul>
              <li>
                <strong>User Responsibility:</strong> You are responsible for safeguarding any credentials used to access your account and for any activities under your account.
              </li>
              <li>
                <strong>User-Generated Flashcards:</strong> If the Service allows you to create, upload, or share custom flashcards or notes (&ldquo;User Content&rdquo;), you retain ownership of your content. However, you grant me a worldwide, non-exclusive, royalty-free license to host, store, and display that content to provide the Service.
              </li>
              <li>
                You agree not to upload content that infringes on third-party intellectual property rights or is unlawful, defamatory, or abusive.
              </li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Service Modifications &amp; Termination</h2>
            <p>Because FreeFlash is a prototype, I reserve the right to:</p>
            <ul>
              <li>Modify, suspend, or discontinue the Service (or any part or feature thereof) at any time, with or without notice.</li>
              <li>Delete user accounts, saved flashcard decks, or progress data at my sole discretion without liability.</li>
              <li>Terminate or suspend your access immediately, without prior notice or liability, for any reason whatsoever.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless me and FreeFlash from and against any and all claims, damages, obligations, losses, liabilities, costs, or debt, and expenses (including but not limited to attorney&apos;s fees), resulting from or arising out of:
            </p>
            <ol type="a">
              <li>Your use and access of the Service.</li>
              <li>Your violation of any term of these Terms.</li>
              <li>Your violation of any third-party right, including without limitation any copyright, property, or privacy right.</li>
            </ol>
          </section>

          <section className="terms-section">
            <h2>6. Governing Law</h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of California, USA, without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Changes to Terms</h2>
            <p>
              I reserve the right, at my sole discretion, to modify or replace these Terms at any time. By continuing to access or use my Service after those revisions become effective, you agree to be bound by the revised terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Contact Me</h2>
            <p>Alright guys thanks for reading. If you have any questions, please contact me at:</p>
            <p className="terms-contact">
              Email:{' '}
              <a href="mailto:maxhuddleston@berkeley.edu" className="terms-link">
                maxhuddleston@berkeley.edu
              </a>
            </p>
          </section>

          <div className="terms-actions">
            <button
              type="button"
              className="terms-btn terms-btn-primary"
              onClick={handleReturnHome}
            >
              Return to Home
            </button>
            <button
              type="button"
              className="terms-btn terms-btn-secondary"
              onClick={handleGoBack}
            >
              Go Back
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default TermsOfService;
